import { PatternValidationRegex } from '~domain/helper/validation-regex';
import { ErrorMessage, Rule } from '~domain/model/core/validation/rule';
import { BaseValidator } from '~domain/validators/core/base-validator';

export class StreetNumberValidator extends BaseValidator<string> {
  protected rules: Rule<string>[] = [this.createNullRule(), this.validateContent];

  private validateContent(value: string): ErrorMessage {
    if (!PatternValidationRegex.ALPHANUMERIC_REGEX.test(value) && !PatternValidationRegex.POSTAL_BOXES.test(value)) {
      return 'validation.error.invalidString';
    }
  }
}
